import React from 'react';

const SelectSkeleton = () => {
  return (
    <div className="space-y-4">
      <div>
        <div className="mb-2 h-2.5 w-16 rounded bg-gray-200 animate-pulse" />
        <div className="h-12 w-full rounded-lg border-[0.5px] border-gray-200 bg-gray-100 animate-pulse" />
      </div>
      <div>
        <div className="mb-2 h-2.5 w-16 rounded bg-gray-200 animate-pulse" />
        <div className="h-12 w-full rounded-lg border-[0.5px] border-gray-200 bg-gray-100 animate-pulse" />
      </div>
    </div>
  );
};

export default SelectSkeleton;
